import Timer from 'otp-timer';
import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import OtpInput from 'react-otp-input';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'sonner';
import { AuthContext } from '../../context/AuthContextProvider';
import nopreview from '../../assets/images/others/no-preview.png';

const CollectingAgents = () => {


  return (
    <>
      <Helmet>
        <title>Spandan  - Collecting Agents</title>
      </Helmet>

      <div className="main-wrappers" >


        <div className="page-wrapper">
          <div className="content">
            <div >
              <h4><strong>Collecting Agents</strong></h4>



            </div>
          </div>
        </div>
      </div>

    </>
  );
}




export default CollectingAgents;
